
import { Options, Vue } from 'vue-class-component';
import Greet from '@/components/Greet.vue'; // @ is an alias to /src

@Options({
  components: {
    Greet,
  },
})
export default class Home extends Vue {}
